import * as React from 'react';
import classnames from 'classnames';
import { Container } from '@grandvisionhq/elements';

const PromotionBanners = ({ children , fullWidth =false  })=>{
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('promotion-banners', {
            'promotion-banners--full-width': fullWidth
        }),
        "data-t": "promotion-banners"
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "promotion-banners__container"
    }, children));
};

export { PromotionBanners as default };
//# sourceMappingURL=PromotionBanners.js.map
